import React, { useState } from "react";

export const Image = ({ title, largeImage, smallImage }) => {
  const [showLarge, setShowLarge] = useState(false);

  const handleClick = (e) => {
    e.preventDefault();
    setShowLarge(true);
    document.body.style.overflow = "hidden";
  };

  const handleClose = () => {
    setShowLarge(false);
    document.body.style.overflow = "auto";
  };

  return (
    <div className="portfolio-item">
      <div className="hover-bg">
        <a href={largeImage} onClick={handleClick} title={title}>
          <div className="hover-text">
            <h4>{title}</h4>
          </div>
          <img src={smallImage} className="img-responsive" alt={title} />
        </a>
      </div>
      {showLarge && (
        <div className="lightbox-overlay" onClick={handleClose}>
          <button className="lightbox-close" onClick={handleClose}>
            ×
          </button>
          <div className="lightbox-container">
            <img src={largeImage} alt={title} className="lightbox-image" />
          </div>
        </div>
      )}
    </div>
  );
};
